<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <el-form ref="form2" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl2" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">保 存</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "SystemPersonal",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'person',
      breadcrumb: [
        { name: "系统设置" },
        { name: "个人设置" },
      ],
      formCtrl: [
        {
          label: "姓名",
          keyName: "name",
          err: "请填写姓名",
          type: "text",
        },
        {
          label: "性别",
          keyName: "sex",
          err: "请选择性别",
          type: "select",
          options: [],
        },
        {
          label: "年龄（岁）",
          keyName: "age",
          err: "请填写年龄",
          type: "text",
        },
        {
          label: "生日",
          keyName: "birthday",
          err: "请选择生日",
          type: "date",
        },
        {
          label: "状态",
          keyName: "iswork",
          err: "请选择状态",
          type: "select",
          options: [],
        },
        {
          label: "学历",
          keyName: "edu",
          err: "请选择学历",
          type: "select",
          options: [],
        },
        {
          label: "联系方式",
          keyName: "tel",
          err: "请填写联系方式",
          type: "text",
        },
        {
          label: "民族",
          keyName: "nation",
          err: "请填写民族",
          type: "text",
        },
        {
          label: "籍贯",
          keyName: "province",
          err: "请填写籍贯",
          type: "text",
        },
        {
          label: "住址",
          keyName: "address",
          err: "请填写住址",
          type: "text",
        },
        {
          label: "紧急联系人",
          keyName: "contact",
          err: "请填写紧急联系人姓名",
          type: "text",
        },
        {
          label: "紧急联系人联系方式",
          keyName: "contacttel",
          err: "请填写紧急联系人联系方式",
          type: "text",
        },
        {
          label: "身份证正反面",
          keyName: "identitycard",
          tips: "最多上传2张图片",
          type: "file",
          max: 2,
        },
      ],
      formCtrl2: [
        {
          label: "账号",
          keyName: "username",
          err: "请填写账号",
          type: "text",
          disabled: true,
        },
        {
          label: "密码",
          keyName: "password",
          err: "请填写密码",
          type: "password",
        },
      ],
    };
  },
  methods: {
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/index`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data, edu, iswork }) => {
        if (msg === 'success' && data) {
          this.detail = data
          const formCtrl = [...this.formCtrl, ...this.formCtrl2]
          formCtrl.map(v => {
            const key = v.keyName
            this.form[key] = this.detail[key];
          })
          this.form.id = data.id
          this.$forceUpdate()
          // console.log({ ...this.detail })
          // console.log({ ...this.form })
          this.setOptions({ edu, iswork })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions({ iswork, edu }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'iswork' && iswork.length) {
          c.options = iswork.map(v => {
            return {
              label: v.iswork,
              value: Number(v.id),
            }
          })
          // console.log([...c.options])
        }
        if (c.keyName == 'edu' && edu.length) {
          c.options = edu.map(v => {
            return {
              label: v.eduname,
              value: v.id + '',
            }
          })
          // console.log([...c.options])
        }
      })
      // console.log({ ...this.form })
    },
    onSubmit() {
      console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/getpassword`;
      const params = {
        userid: this.user.id,
      }
      const object = this.form
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
